const LoadingSpinner = ({ size = 16 }) => (
  <div className="flex justify-center items-center h-full">
    <div
      className="animate-spin rounded-full border-t-velBlue border-r-transparent border-b-transparent border-l-transparent"
      style={{
        height: `${size}px`,
        width: `${size}px`,
        borderWidth: `${Math.max(2, size / 8)}px`,
      }}
    />
  </div>
);

export default LoadingSpinner;
